import React from "react";

import { ServerDeletedFilterValue } from "./ServerListFilters";

interface ServerDeletedPillsProps {
  value: ServerDeletedFilterValue;
  onChange: (value: ServerDeletedFilterValue) => void;
}

/**
 * Compact two-state deleted-record filter.
 *
 * Default state shows current records. Clicking the button shows only
 * soft-deleted records; clicking it again returns to current records.
 * The former "Records" label and "All" option are intentionally removed.
 */
const ServerDeletedPills: React.FC<ServerDeletedPillsProps> = ({
  value,
  onChange,
}) => {
  const showingDeleted = value === "true";

  const toggleDeletedRecords = () => {
    onChange(showingDeleted ? "false" : "true");
  };

  return (
    <button
      type="button"
      aria-pressed={showingDeleted}
      aria-label={
        showingDeleted
          ? "Return to current records"
          : "Show soft-deleted records"
      }
      title={
        showingDeleted
          ? "Back to current records"
          : "Show deleted records"
      }
      onClick={toggleDeletedRecords}
      style={{
        order: 90,
        width: 34,
        height: 34,
        minWidth: 34,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        borderRadius: 9,
        border: showingDeleted ? "1px solid #dc2626" : "1px solid #cbd5e1",
        background: showingDeleted ? "#dc2626" : "#ffffff",
        color: showingDeleted ? "#ffffff" : "#64748b",
        boxShadow: showingDeleted
          ? "0 2px 6px rgba(220,38,38,0.24)"
          : "0 1px 3px rgba(15,23,42,0.08)",
        cursor: "pointer",
        transition: "all 0.15s ease",
      }}
    >
      <i
        className={`fa-solid ${
          showingDeleted ? "fa-arrow-rotate-left" : "fa-trash-can"
        }`}
        style={{ fontSize: 12 }}
      />
    </button>
  );
};

export default ServerDeletedPills;
